<template>
    <div>
    <el-container style="background: #f3f5fa;padding:5px 0">
        <el-header style="height:auto;padding:0;">
            <div class="content-center">
                <img src="../assets/logo_login.png" width="70" alt="">
                <router-link class="link-style" v-if="token" to="/">home</router-link>
                <!-- <router-link class="link-style" to="/">Durg Info</router-link>
                <router-link class="link-style" to="/">Heahth File</router-link>
                <router-link class="link-style" to="/">Pharmacy Info</router-link>
                <router-link class="link-style" to="/">Operation History</router-link>
                <router-link class="link-style" to="/">Alarm Info</router-link>
                <router-link class="link-style" to="/">Contact</router-link> -->
                <router-link class="user-login" to="/Login" v-if="!token">
                <img style="width:20px;vertical-align: middle;" src="../assets/user_login.png" alt="">
                {{loginText}}
                </router-link>
                <el-popover width="50" trigger="hover" v-if="token">
                    <div class="user-login" slot="reference">
                        <img style="width:20px;vertical-align: middle;" src="../assets/user_login.png" alt="">
                        {{loginText}}
                    </div>
                    <div style="cursor: pointer;text-align: center;" @click="logout">Sign off</div>
                </el-popover>
            </div>
        </el-header>
        <!-- <el-main>Main</el-main>
        <el-footer>Footer</el-footer> -->
    </el-container>
        <!-- <keep-alive> -->
        <router-view @fatherMethod="fatherMethod" @loginout="logout" style="height:70%;display:block;padding-bottom:70px;"></router-view>
        <!-- </keep-alive> -->
        <div class="home-footer">Intellecturl Property Protection - <a href="#" style="color:#fff;text-decoration: underline;">Privacy&nbsp;Policy</a> - Sitemap - Terms of Use - User Information Legal Enquiry Guide ©2010-2020 Geri safe.com.All rights reseved</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            loginText:"Login",
            token: ''
        }
    },
    created(){
        if(localStorage.getItem('key')){
            this.token = localStorage.getItem('key')
        }
        if(localStorage.getItem('userName')){
            this.loginText = localStorage.getItem('userName')
        }
    },
    methods:{
        fatherMethod(res){
            this.loginText = res
            localStorage.setItem('userName',this.loginText)
            this.token = localStorage.getItem('key')
            console.log(res)
        },
        logout(){
            // console.log('xxx');
            // localStorage.removeItem('key')
            this.$confirm('Confirm Exit?', 'tip', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                localStorage.clear()
                this.loginText = 'Login'
                this.token = ''
                this.$router.push({path:'/login'})
            }).catch(() => {

            });
        },
        gettoken(res){
            console.log(res);
            this.token = res
        }
    },
    activated(){
        let user = JSON.parse(sessionStorage.getItem('user'))
        if(user.userinfo.user_nickname){
            this.loginText = user.userinfo.user_nickname
        }else{
            this.loginText = 'Login'
        }
    }
}
</script>

<style scoped>
    body{
        height: 100%;
    }
    .content-center{
        width: 75%;
        margin: 0 auto;  
        display: flex;
        position: relative;
        align-items: center;
        text-align: center;
        line-height: 30px;   
    }
    .link-style{
        display: inline-block;
        width: 9%;
        height: 30px;
        border: 1px solid #000;
        margin: 0 10px;
        border-radius: 5px;
        font-size: 12px;
    }
    .user-login{
        position: absolute;
        right:0;
        width: 9%;
        background: #c1e1f4;
        color: #fff;
        border-radius: 5px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
    .home-footer{
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0;
        z-index: 1;
        background: gray;
        line-height: 50px;
        text-align: center;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue